const React = require('react');
const { useLocation } = require('react-router-dom');
const Menu = require('./Menu');

const NoApis = () => {
  return (
    <menu>
      <h1>Missing APIs</h1>
      <div>
        Looks like we are not able to provide xAPIs right now.
        <br/>You can view the <a href="https://www.cisco.com/c/en/us/support/collaboration-endpoints/spark-room-kit-series/products-command-reference-list.html" target="_blank" style={{ display: 'inline', color: '#007aa3', textDecoration: 'underline' }}>PDF versions here.</a>
      </div>
    </menu>
  )
}

const XapiMenu = (props) => {
  const { domains } = props;
  domains.sort((d1, d2) => d1 < d2 ? -1 : 1);
  const location = useLocation();
  if (!domains.length) return <NoApis />

  const list = domains.map((path) => {
    const url = '/xapi/domain/?domain=' + path;
    const current = new URLSearchParams(location.search).get('domain');

    return { name: path, link: url, isActive: () => current === path };
  });
  const sections = [{ name: 'Reference', items: list, open: true }];

  return <Menu name="xAPI" sections={sections} />;
};

module.exports = XapiMenu;



